export default __webpack_public_path__ + "static/media/chef.a1fd49e5.png";